import AppNavBar from './AppNavBar.vue';

export default AppNavBar;
